import { Tezos } from '@components/design-system';
import { ICurrency } from '@interface/currency';
import { MutToTez } from './format';

export const didExpire = (endTime: string | null) => {
  if (endTime) {
    const currentTime = new Date().valueOf();
    const expiryTime = new Date(endTime).valueOf();

    if (currentTime > expiryTime) {
      return true;
    }
  }

  return false;
};

export const getCurrencyJSX = (mutez: number, currency: ICurrency) => {
  switch (currency.symbol) {
    case 'XTZ':
      return (
        <>
          {MutToTez(mutez)}
          <Tezos />
        </>
      );
    default:
      return null;
  }
};
